import { ArticlesList } from "components/pages/blog/search/ArticlesList";
import { SearchEngine } from "components/pages/blog/search/SearchEngine";
import styles from "./AuthorArticles.module.scss";
import { useAuthorSinglePageContext } from "@/helpers/contexts/AuthorSinglePageContext";
import useBlogSearch, { SearchFilterEntity } from "@/helpers/blog/useBlogSearch";
import { BlogSearch } from "@/components/pages/blog/search/BlogSearch";
import { useClientPagination } from "@/helpers/blog/useClientPagination";
import { useMemo } from "react";

export const AuthorArticles = () => {
  const contextData = useAuthorSinglePageContext();
  const clientPagination = useClientPagination();

  const children = useMemo(() => {
    return (
      contextData?.articles &&
      contextData?.pagination && (
        <ArticlesList list={contextData.articles} pagination={contextData.pagination} />
      )
    );
  }, [contextData?.articles, contextData?.pagination]);

  const { search, handleSearch } = useBlogSearch();

  if (!contextData) return null;
  const { articles, articlesNotFound, pagination, author } = contextData;

  if (!search && !articles.length) return null;
  return (
    <div className={styles.wrapper}>
      <BlogSearch
        search={search}
        count={pagination.total}
        handleSearch={handleSearch}
        isNotFound={articlesNotFound}
        className={styles.blogSearch}
      />
      <SearchEngine
        isSearch={!articlesNotFound && !!search}
        pagination={clientPagination}
        filteredArticles={articles}
        isLoading={false}
      >
        {children}
      </SearchEngine>
    </div>
  );
};
